<div class="container container-wrapper">
  <div class="row justify-content-center">
    <section class="col-12 col-xl-11">
      <h3>{{ "PRIVACY_HEAD" | translate }}</h3>
    </section>
  </div>
  <div class="row justify-content-center">
    <section class="col-12 col-xl-11">
      <app-text-block [prefix]="'PRIVACY'" [index]="1"></app-text-block>
    </section>
  </div>
</div>
